import {
  ACTION_1,
  ACTIVATE_FORM,
  ACTIVATE_USER,
  ADD_ITEM_TO_CART,
  ADD_PROTEGE,
  ALERT_HIDE,
  ALERT_SHOW,
  ALERT_TIMEOUT,
  CHECK_AUTH_DONE,
  CHECK_AUTH_FAILED,
  CHECK_AUTH_START,
  COPY_FORM_TO_FORM_GROUP_DONE,
  COPY_FORM_TO_FORM_GROUP_FAILED,
  COPY_FORM_TO_FORM_GROUP_START,
  CREATE_FILLED_FORM_DATA_DONE,
  CREATE_FILLED_FORM_DATA_FAILED,
  CREATE_FILLED_FORM_DATA_START,
  DEACTIVATE_FORM,
  DONE,
  DUPLICATE_FORM,
  EDIT_ITEM_CART,
  EDIT_PROTEGE,
  FAILED,
  FETCH_ACTIVATED_KITS,
  FETCH_ACTIVE_FORMS,
  FETCH_ACTIVE_FORMS_ALL,
  FETCH_USER_ALL_FORMS,
  FETCH_USER_ALL_AVAILABLE_FORMS,
  FETCH_PLANNED_FORMS,
  FETCH_PLANNED_FORMS_ALL,
  FETCH_ARCHIVED_FORMS,
  FETCH_ARCHIVED_FORMS_BAG,
  FETCH_ALL_MY_TESTS,
  FETCH_CONFIG_GLOBAL_DONE,
  FETCH_CONFIG_GLOBAL_FAILED,
  FETCH_CONFIG_GLOBAL_START,
  FETCH_DATA_AS_CSV,
  FETCH_FILLED_FORMS_DONE,
  FETCH_FILLED_FORMS_EXTENDED,
  FETCH_FILLED_FORMS_FAILED,
  FETCH_FILLED_FORMS_START,
  FETCH_FILLED_TESTS,
  FETCH_FORM_TEMPLATE_DONE,
  FETCH_FORM_TEMPLATE_FAILED,
  FETCH_FORM_TEMPLATE_START,
  FETCH_FORM_DONE,
  FETCH_FORM_EDITIONS,
  FETCH_FORM_FAILED,
  FETCH_FORM_GROUP_DONE,
  FETCH_FORM_GROUP_FAILED,
  FETCH_FORM_GROUP_START,
  FETCH_GLOBAL_DICTIONARIES_DONE,
  FETCH_GLOBAL_DICTIONARIES_FAILED,
  FETCH_GLOBAL_DICTIONARIES_START,
  FETCH_FORM_START,
  FETCH_FORMS_DONE,
  FETCH_FORMS_FAILED,
  FETCH_FORMS_GROUPS_DONE,
  FETCH_FORMS_GROUPS_FAILED,
  FETCH_FORMS_GROUPS_START,
  FETCH_ALL_FORMS_GROUPS_DONE,
  FETCH_ALL_FORMS_GROUPS_FAILED,
  FETCH_ALL_FORMS_GROUPS_START,
  FETCH_FORMS_START,
  FETCH_OLD_FORM_EDITIONS,
  FETCH_ORDER_DETAILS_BY_ORDER_ID,
  FETCH_ORG_NAMES_DONE,
  FETCH_ORG_NAMES_FAILED,
  FETCH_ORG_NAMES_START,
  FETCH_ORG_USERS_DONE,
  FETCH_ORG_USERS_FAILED,
  FETCH_ORG_USERS_START,
  FETCH_ALL_ORG_USERS_DONE,
  FETCH_ALL_ORG_USERS_FAILED,
  FETCH_ALL_ORG_USERS_START,
  FETCH_ORGANIZATION_DONE,
  FETCH_ORGANIZATION_FAILED,
  FETCH_ORGANIZATION_START,
  FETCH_SCHEDULED_FORMS,
  FETCH_PROTEGES,
  FETCH_ALL_PROTEGES,
  INVITE_MULTIPLE_PEOPLE_DONE,
  INVITE_MULTIPLE_PEOPLE_FAILED,
  INVITE_MULTIPLE_PEOPLE_START,
  JOIN_ORGANIZATION_DONE,
  JOIN_ORGANIZATION_FAILED,
  JOIN_ORGANIZATION_START,
  LOGIN_DONE,
  LOGIN_FAILED,
  LOGIN_START,
  LOGOUT_DONE,
  LOGOUT_FAILED,
  LOGOUT_START,
  MOVE_FORM_TO_FORM_GROUP_DONE,
  MOVE_FORM_TO_FORM_GROUP_FAILED,
  MOVE_FORM_TO_FORM_GROUP_START,
  RECOVER_PASSWORD_DONE,
  RECOVER_PASSWORD_FAILED,
  RECOVER_PASSWORD_START,
  RESET_BY_MAIL_PASSWORD_DONE,
  RESET_BY_MAIL_PASSWORD_FAILED,
  RESET_BY_MAIL_PASSWORD_START,
  REGISTER_ORGANIZATION_DONE,
  REGISTER_ORGANIZATION_FAILED,
  REGISTER_ORGANIZATION_START,
  REGISTER_PERSON,
  REMOVE_FORM_DONE,
  REMOVE_FORM_START,
  REMOVE_FORM_FAILED,
  REMOVE_FORM_FROM_FORM_GROUP_DONE,
  REMOVE_FORM_FROM_FORM_GROUP_FAILED,
  REMOVE_FORM_FROM_FORM_GROUP_START,
  REMOVE_ITEM_FROM_CART,
  REMOVE_USER,
  REMOVE_PROTEGE,
  EDIT_USER,
  SAVE_FILLED_FORM_DATA_DONE,
  SAVE_FILLED_FORM_DATA_FAILED,
  SAVE_FILLED_FORM_DATA_START,
  EDIT_FILLED_FORM_DATA_DONE,
  EDIT_FILLED_FORM_DATA_FAILED,
  EDIT_FILLED_FORM_DATA_START,
  SAVE_FORM_DONE,
  SAVE_FORM_FAILED,
  SAVE_FORM_START,
  SAVE_FORM_GROUP_DONE,
  SAVE_FORM_GROUP_FAILED,
  SAVE_FORM_GROUP_START,
  SAVE_QR_CODE,
  ADD_PRODUCT,
  EDIT_PRODUCT,
  REMOVE_PRODUCT,
  GET_PRODUCTS,
  GET_PURCHASED_PRODUCTS,
  GET_ORDER_DETAILS,
  SEND_COMMENT_DONE,
  SEND_COMMENT_FAILED,
  SEND_COMMENT_START,
  SET_APP_BAR_TITLE,
  START,
  TOGGLE_REQUESTED_SHARING_BY_OWNER,
  UPDATE_ENTITLED_USERS,
  UPDATE_FORM_DATA_IS_SHARED,
  UPDATE_FORM_DONE,
  UPDATE_FORM_FAILED,
  UPDATE_FORM_START,
  UPDATE_REQUESTED_SHARING_BY_OWNER,
  REMOVE_FORM_GROUP,
  ADD_PERSON,
  ASSIGN_PERSON,
  PATIENTS_NOT_ASSIGNED,
  DUPLICATE_FORM_GROUP,
  FETCH_ALLOWED_USERS_TO_GROUP_START,
  FETCH_ALLOWED_USERS_TO_GROUP_DONE,
  FETCH_ALLOWED_USERS_TO_GROUP_FAILED,
  FETCH_ALLOWED_USERS_TO_FORM_START,
  FETCH_ALLOWED_USERS_TO_FORM_DONE,
  FETCH_ALLOWED_USERS_TO_FORM_FAILED,
  UPDATE_USERS_ACCESS_TO_GROUP,
  UPDATE_USERS_ACCESS_TO_FORM,
  FETCH_FORM_DATA,
  FETCH_UPLOADABLE_FILE_TYPES,
  FETCH_SAVED_FORM_DATA,
  FETCH_FILLED_FORM_DATA,
  REMOVE_FORM_DATA_DRAFT,
  FETCH_MATCHING_USERS,
  FETCH_FORMS_SCHEDULED_FOR_FUTURE,
  RESET_GIVEN_USER_PASSWORD,
  FETCH_API_KEYS,
  ADD_API_KEY,
  DELEETE_API_KEY,
  FETCH_SCHEDULED_FORM,
  FETCH_HAS_SINGLE_SCHEDULED_FORM,
  ALERT_HIDE_CUSTOM_ID,
  TOGGLE_GLOBAL_THEME,
  COOKIES_ACCEPTED,
  FETCH_COOKIES_ACCEPTED,
  READ_GLOBAL_THEME,
  READ_FONT_SIZE,
  SET_FONT_SIZE,
  FETCH_CONFIG,
  CLEAR_ALL_FORM,
  FETCH_TERMS_ACCEPTED_BY_USER_WITH_ID,
  FETCH_API_VERSION,
  UNSUPPORTED_BROWSER,
  SEND_CONTACT,
  FETCH_QR_CODE,
  FETCH_VOUCHER_INFO,
  FETCH_SCREENING_INFO,
  FETCH_PACKAGE_INFO,
  FETCH_PACKAGS,
  FETCH_ASSIGNED_SCREENINGS,
  FETCH_STANDS,
  FETCH_STANDS_WITH_PUPILS,
} from "../../constants";
import { getAxiosInstance, refreshAxios } from "../common";

refreshAxios();

export const action1 = (payload) => ({ type: ACTION_1, payload });

/**
 *
 * @param payload {name, mail, password}
 * @returns {Function}
 */
export const register_organization = (payload) => async (dispatch) => {
  dispatch(register_organization_start());
  try {
    refreshAxios();

    const result = await getAxiosInstance().post(
      "/api/organizations/register",
      {
        orgName: payload.name,
        mail: payload.mail,
        password: payload.password,
      }
    );

    dispatch(register_organization_done(result.data));
    return result;
  } catch (e) {
    dispatch(register_organization_failed(e));
    return e.response;
  }
};

export const registerPerson = (payload) => async (dispatch) => {
  dispatch({ type: REGISTER_PERSON + START });
  try {
    const result = await getAxiosInstance().post(
      "/api/persons/register",
      payload
    );

    dispatch({ type: REGISTER_PERSON + DONE, payload: result.data });
    return true;
  } catch (e) {
    dispatch({
      type: REGISTER_PERSON + FAILED,
      e,
    });
    throw e;
  }
};

export const join_organization = (payload) => async (dispatch) => {
  dispatch(join_organization_start());
  try {
    refreshAxios();

    const result = await getAxiosInstance().post(
      `/api/organizations/${payload.selectedOrg}/join`,
      {
        mail: payload.mail,
        password: payload.password,
        ...(payload.orgCode ? { orgCode: payload.orgCode } : {}),
        acceptedTerms: payload.acceptedTerms,
      }
    );

    dispatch(join_organization_done(result.data));
    return result.data;
  } catch (e) {
    dispatch(join_organization_failed(e));
    throw e;
  }
};

export const register_organization_start = (payload) => ({
  type: REGISTER_ORGANIZATION_START,
  payload,
});
export const register_organization_done = (payload) => ({
  type: REGISTER_ORGANIZATION_DONE,
  payload,
});
export const register_organization_failed = (payload) => ({
  type: REGISTER_ORGANIZATION_FAILED,
  payload,
});

export const join_organization_start = (payload) => ({
  type: JOIN_ORGANIZATION_START,
  payload,
});
export const join_organization_done = (payload) => ({
  type: JOIN_ORGANIZATION_DONE,
  payload,
});
export const join_organization_failed = (payload) => ({
  type: JOIN_ORGANIZATION_FAILED,
  payload,
});

/**
 *
 * @param payload {username, password}
 * @returns {Function}
 */
export const login = (payload, loginType) => async (dispatch) => {
  dispatch(login_start());
  try {
    refreshAxios();
    const result =
      loginType !== "patient"
        ? await getAxiosInstance().post("/employees/v1/login", {
            email: payload.username,
            password: payload.password,
          })
        : await getAxiosInstance().post(
            "/api/auth/login",
            payload.username === "" || payload.username === undefined
              ? {
                  phone: payload.phone,
                  password: payload.password,
                  globalTosAccepted: payload.globalTosAccepted,
                }
              : {
                  username: payload.username,
                  password: payload.password,
                  globalTosAccepted: payload.globalTosAccepted,
                }
          );

    refreshAxios(result.data.token);

    const my = await getAxiosInstance().get("/api/persons/my");

    dispatch(
      login_done({
        data: result.data,
        my: my.data,
      })
    );

    window &&
      window.localStorage &&
      window.localStorage.setItem("loggedIn", new Date().toISOString());

    return result;
  } catch (e) {
    dispatch(login_failed(e));
    return e.response;
  }
};

export const login_start = (payload) => ({ type: LOGIN_START, payload });
export const login_done = (payload) => ({ type: LOGIN_DONE, payload });
export const login_failed = (payload) => ({
  type: LOGIN_FAILED,
  errorMessage: payload.response.data.message,
  payload,
});

export const checkAuth = () => async (dispatch) => {
  dispatch(checkAuth_start());
  try {
    await refreshAxios();

    // const result = await getAxiosInstance().get("/api/auth/refresh");

    const my = await getAxiosInstance().get("/api/persons/my");

    dispatch(
      checkAuth_done({
        // token: result.data.token,
        my: my.data,
      })
    );
    return true;
  } catch (e) {
    dispatch(checkAuth_failed(e));
    return false;
  }
};

export const checkAuth_start = (payload) => ({
  type: CHECK_AUTH_START,
  payload,
});
export const checkAuth_done = (payload) => ({ type: CHECK_AUTH_DONE, payload });
export const checkAuth_failed = (payload) => ({
  type: CHECK_AUTH_FAILED,
  payload,
});

export const fetchOrgUsers = (payload) => async (dispatch) => {
  dispatch(fetchAllOrgUsers_start());
  try {
    const result = await getAxiosInstance().get("/api/persons");

    dispatch(fetchAllOrgUsers_done({ users: result.data }));
    return true;
  } catch (e) {
    dispatch(fetchAllOrgUsers_failed(e));
    return false;
  }
};

export const fetchOrgUsersWithTerms = ({
  page,
  pageSize,
  sortBy,
  filterRole,
  filterProperty,
}) => async (dispatch) => {
  dispatch(fetchOrgUsers_start());
  try {
    const result = await getAxiosInstance().get("/api/v2/persons/with_terms", {
      params: {
        page,
        ...(pageSize ? { pageSize } : {}),
        ...(sortBy ? { sortBy } : {}),
        ...(filterRole ? { filterRole } : {}),
        ...(filterProperty ? { filterProperty } : {}),
      },
    });

    dispatch(fetchOrgUsers_done({ users: result.data }));
    return true;
  } catch (e) {
    dispatch(fetchOrgUsers_failed(e));
    return false;
  }
};

export const fetchOrgUsersPaged = ({
  page,
  pageSize,
  sortBy,
  filterRole,
  filterProperty,
}) => async (dispatch) => {
  dispatch(fetchOrgUsers_start());
  try {
    const result = await getAxiosInstance().get("/api/v2/persons", {
      params: {
        page,
        ...(pageSize ? { pageSize } : {}),
        ...(sortBy ? { sortBy } : {}),
        ...(filterRole ? { filterRole } : {}),
        ...(filterProperty ? { filterProperty } : {}),
      },
    });

    dispatch(fetchOrgUsers_done({ users: result.data }));
    return true;
  } catch (e) {
    dispatch(fetchOrgUsers_failed(e));
    return false;
  }
};

export const fetchOrgUsers_start = (payload) => ({
  type: FETCH_ORG_USERS_START,
  payload,
});

export const fetchOrgUsers_done = (payload) => ({
  type: FETCH_ORG_USERS_DONE,
  payload,
});

export const fetchOrgUsers_failed = (payload) => ({
  type: FETCH_ORG_USERS_FAILED,
  payload,
});

export const fetchAllOrgUsers_start = (payload) => ({
  type: FETCH_ALL_ORG_USERS_START,
  payload,
});

export const fetchAllOrgUsers_done = (payload) => ({
  type: FETCH_ALL_ORG_USERS_DONE,
  payload,
});

export const fetchAllOrgUsers_failed = (payload) => ({
  type: FETCH_ALL_ORG_USERS_FAILED,
  payload,
});

export const fetchOrgNames = (payload) => async (dispatch) => {
  dispatch(fetchOrgNames_start());
  try {
    const result = await getAxiosInstance().get("/api/organizations/names");
    dispatch(fetchOrgNames_done({ orgNames: result.data }));
    return result.data;
  } catch (e) {
    dispatch(fetchOrgNames_failed(e));
    return false;
  }
};

export const fetchOrgNames_start = (payload) => ({
  type: FETCH_ORG_NAMES_START,
  payload,
});
export const fetchOrgNames_done = (payload) => ({
  type: FETCH_ORG_NAMES_DONE,
  payload,
});
export const fetchOrgNames_failed = (payload) => ({
  type: FETCH_ORG_NAMES_FAILED,
  payload,
});

export const fetchProteges = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_PROTEGES + START });
  try {
    const result = await getAxiosInstance().get(`/api/auth/subaccount`, {
      params: payload,
    });
    dispatch({
      type: FETCH_PROTEGES + DONE,
      payload: result.data,
    });
    return result.data.content;
  } catch (e) {
    dispatch({ type: FETCH_PROTEGES + FAILED, payload: e });
  }
};

export const fetchAllProteges = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_ALL_PROTEGES + START });
  try {
    const result = await getAxiosInstance().get(`/api/subaccount`);
    dispatch({
      type: FETCH_ALL_PROTEGES + DONE,
      payload: result.data,
    });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_ALL_PROTEGES + FAILED, payload: e });
  }
};

export const addPerson = ({ person, orgId }) => async (dispatch) => {
  dispatch({ type: ADD_PERSON + START });

  try {
    const res = await getAxiosInstance().post(
      `/api/organizations/${orgId}/add_user`,
      person
    );
    dispatch({ type: ADD_PERSON + DONE, payload: res.data });
    return res.data;
  } catch (e) {
    dispatch({ type: ADD_PERSON + FAILED, payload: e });
    throw e;
  }
};

export const patientsNotAssigned = ({ screeningId }) => async (dispatch) => {
  dispatch({ type: PATIENTS_NOT_ASSIGNED + START });

  try {
    const res = await getAxiosInstance().get(
      `/api/assignment/account_patients_not_assigned_to_screening?screeningId=${screeningId}`
    );

    dispatch({ type: PATIENTS_NOT_ASSIGNED + DONE, payload: res.data });

    return res;
  } catch (e) {
    dispatch({ type: PATIENTS_NOT_ASSIGNED + FAILED, payload: e });
    throw e;
  }
};

export const assignPerson = ({ voucherId, subaccountId }) => async (
  dispatch
) => {
  dispatch({ type: ASSIGN_PERSON + START });

  try {
    let res = null;
    if (subaccountId) {
      res = await getAxiosInstance().put(
        `/api/voucher/${voucherId}/assign_to_subaccount/${subaccountId}`
      );
    } else {
      res = await getAxiosInstance().put(
        `/api/voucher/${voucherId}/assign_to_me`
      );
    }

    dispatch({ type: ASSIGN_PERSON + DONE, payload: res.data });

    return res;
  } catch (e) {
    dispatch({ type: ASSIGN_PERSON + FAILED, payload: e });
    throw e;
  }
};

export const assignPurchasedTest = ({
  orderId,
  orderItemId,
  subaccountId,
}) => async (dispatch) => {
  dispatch({ type: ASSIGN_PERSON + START });

  try {
    let res = null;
    if (subaccountId) {
      res = await getAxiosInstance().put(
        `/api/order/${orderId}/order_item/${orderItemId}/assign_to_subaccount/${subaccountId}`
      );
    } else {
      res = await getAxiosInstance().put(
        `/api/order/${orderId}/order_item/${orderItemId}/assign_to_me`
      );
    }

    dispatch({ type: ASSIGN_PERSON + DONE, payload: res.data });

    return res;
  } catch (e) {
    dispatch({ type: ASSIGN_PERSON + FAILED, payload: e });
    throw e;
  }
};

export const addProtege = (payload) => async (dispatch) => {
  dispatch({ type: ADD_PROTEGE + START });

  try {
    const res = await getAxiosInstance().post(`/api/auth/subaccount`, payload);
    dispatch({ type: ADD_PROTEGE + DONE, payload: res.data });
    return res.data;
  } catch (e) {
    dispatch({ type: ADD_PROTEGE + FAILED, payload: e });
    throw e;
  }
};

export const editProtege = (protegeId, payload) => async (dispatch) => {
  dispatch({ type: EDIT_PROTEGE + START });

  try {
    const res = await getAxiosInstance().put(
      `/api/auth/subaccount/${protegeId}`,
      payload
    );
    dispatch({ type: EDIT_PROTEGE + DONE, payload: res.data });
    return res.data;
  } catch (e) {
    dispatch({ type: EDIT_PROTEGE + FAILED, payload: e });
    throw e;
  }
};

export const removeProtege = (protegeId) => async (dispatch) => {
  dispatch({ type: REMOVE_PROTEGE + START });

  try {
    const res = await getAxiosInstance().delete(
      `/api/auth/subaccount/${protegeId}`
    );
    dispatch({ type: REMOVE_PROTEGE + DONE, payload: res.data });
    return res.data;
  } catch (e) {
    dispatch({ type: REMOVE_PROTEGE + FAILED, payload: e });
    throw e;
  }
};

export const inviteMultiplePeople = (payload) => async (dispatch) => {
  dispatch(inviteMultiplePeople_start());

  try {
    const res = await getAxiosInstance().post(
      `/api/organizations/${payload.orgId}/add_users`,
      payload.persons
    );

    dispatch(inviteMultiplePeople_done({ users: res }));
    return res.data;
  } catch (e) {
    dispatch(inviteMultiplePeople_failed(e));
    return {
      error: e,
    };
  }
};

export const inviteMultiplePeople_start = (payload) => ({
  type: INVITE_MULTIPLE_PEOPLE_START,
  payload,
});

export const inviteMultiplePeople_done = (payload) => ({
  type: INVITE_MULTIPLE_PEOPLE_DONE,
  payload,
});

export const inviteMultiplePeople_failed = (payload) => ({
  type: INVITE_MULTIPLE_PEOPLE_FAILED,
  payload,
});

//////////// logout

export const logout = ({ isUser }) => async (dispatch) => {
  dispatch(logoutStart());

  try {
    const result = isUser
      ? await getAxiosInstance().post("/api/auth/logout")
      : await getAxiosInstance().post("/employees/v1/logout");
    dispatch(logoutDone(result));

    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener("popstate", function (event) {
      window.history.pushState(null, document.title, window.location.href);
    });

    if (window && window.localStorage) {
      window.localStorage.setItem("loggedOut", new Date().toISOString());
      window.localStorage.setItem("firstUrl", "/login");
    }

    return true;
  } catch (e) {
    dispatch(logoutFailed());
  }

  return false;
};

export const logoutStart = (payload) => ({ type: LOGOUT_START, payload });

export const logoutDone = (payload) => ({ type: LOGOUT_DONE, payload });

export const logoutFailed = (payload) => ({ type: LOGOUT_FAILED, payload });

//// save  form

export const saveForm = (payload) => async (dispatch) => {
  dispatch(saveFormStart());
  try {
    const result = await getAxiosInstance().post(`/api/forms`, payload);
    dispatch(saveFormDone(result.data));
    // dispatch(fetchHasSingleScheduledForm());
    return result.data;
  } catch (e) {
    dispatch(saveFormFailed(e));
    return null;
  }
};

export const saveFormStart = (payload) => ({ type: SAVE_FORM_START, payload });

export const saveFormDone = (payload) => ({ type: SAVE_FORM_DONE, payload });

export const saveFormFailed = (payload) => ({
  type: SAVE_FORM_FAILED,
  payload,
});

//// update  form

export const updateForm = (id, payload) => async (dispatch) => {
  dispatch(updateFormStart());
  try {
    const result = await getAxiosInstance().put(`/api/forms/${id}`, payload);
    dispatch(updateFormDone(result.data));
    dispatch(
      fetchForms({
        page: 0,
        pageSize: 100,
      })
    );
    return result.data;
  } catch (e) {
    dispatch(updateFormFailed(e));
    return null;
  }
};
const updateFormStart = (payload) => ({ type: UPDATE_FORM_START, payload });
const updateFormDone = (payload) => ({ type: UPDATE_FORM_DONE, payload });
const updateFormFailed = (payload) => ({ type: UPDATE_FORM_FAILED, payload });

//// save  form group

export const saveFormGroup = (payload) => async (dispatch) => {
  dispatch(saveFormGroupStart());
  try {
    const result = await getAxiosInstance().post(`/api/form_group`, payload);
    dispatch(saveFormGroupDone(result.data));
    return result.data;
  } catch (e) {
    dispatch(saveFormGroupFailed(e));
    return null;
  }
};

export const saveFormGroupStart = (payload) => ({
  type: SAVE_FORM_GROUP_START,
  payload,
});

export const saveFormGroupDone = (payload) => ({
  type: SAVE_FORM_GROUP_DONE,
  payload,
});

export const saveFormGroupFailed = (payload) => ({
  type: SAVE_FORM_GROUP_FAILED,
  payload,
});

//// remove form group

export const removeFormGroup = (id) => async (dispatch) => {
  dispatch({ type: REMOVE_FORM_GROUP + START });
  try {
    const result = await getAxiosInstance().delete(`/api/form_group/${id}`);
    dispatch({ type: REMOVE_FORM_GROUP + DONE, payload: id });
    return result.data;
  } catch (e) {
    dispatch({ type: REMOVE_FORM_GROUP + FAILED, payload: e });
  }
};

//// update  form group

export const updateFormGroup = (id, payload) => async (dispatch) => {
  dispatch(updateFormGroupStart());
  try {
    const result = await getAxiosInstance().put(
      `/api/form_group/${id}`,
      payload
    );
    dispatch(updateFormGroupDone(result.data));
    return result.data;
  } catch (e) {
    dispatch(updateFormGroupFailed(e));
    return null;
  }
};
const updateFormGroupStart = (payload) => ({
  type: UPDATE_FORM_START,
  payload,
});
const updateFormGroupDone = (payload) => ({ type: UPDATE_FORM_DONE, payload });
const updateFormGroupFailed = (payload) => ({
  type: UPDATE_FORM_FAILED,
  payload,
});

export const duplicateFormGroup = (id, payload) => async (dispatch) => {
  dispatch({ type: DUPLICATE_FORM_GROUP + START, id });
  try {
    const result = await getAxiosInstance().put(
      `/api/form_group/${id}/duplicate`,
      payload
    );

    dispatch({ type: DUPLICATE_FORM_GROUP + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: DUPLICATE_FORM_GROUP + FAILED, id });
    return null;
  }
};

export const duplicateForm = (id) => async (dispatch) => {
  dispatch({ type: DUPLICATE_FORM + START, id });
  try {
    const result = await getAxiosInstance().put(`/api/forms/${id}/duplicate`);
    dispatch({ type: DUPLICATE_FORM + DONE, payload: result.data });
    dispatch(
      fetchForms({
        page: 0,
        pageSize: 100,
      })
    );
    return result.data;
  } catch (e) {
    dispatch({ type: DUPLICATE_FORM + FAILED, id });
    return null;
  }
};

export const deactivateForm = (id) => async (dispatch) => {
  dispatch({ type: DEACTIVATE_FORM + START, id });
  try {
    const result = await getAxiosInstance().put(`/api/forms/${id}/deactivate`);
    dispatch({ type: DEACTIVATE_FORM + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: DEACTIVATE_FORM + FAILED, id });
    return null;
  }
};

export const fetchQRCode = () => async (dispatch) => {
  dispatch({ type: FETCH_QR_CODE + START });
  try {
    const result = await getAxiosInstance().get("/api/persons/auth-token");

    dispatch({ type: FETCH_QR_CODE + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_QR_CODE + FAILED });
    return null;
  }
};

export const fetchVoucherInfo = (voucherID) => async (dispatch) => {
  dispatch({ type: FETCH_VOUCHER_INFO + START });
  try {
    const result = await getAxiosInstance().get(`/api/voucher/${voucherID}`);

    dispatch({ type: FETCH_VOUCHER_INFO + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_VOUCHER_INFO + FAILED });
    return null;
  }
};

export const fetchScreeningInfo = (tenantId, screeningId) => async (
  dispatch
) => {
  dispatch({ type: FETCH_SCREENING_INFO + START });

  try {
    const result = await getAxiosInstance().get(`/screening/v1/patient`, {
      params: {
        tenantId,
        screeningId,
      },
    });

    dispatch({ type: FETCH_SCREENING_INFO + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_SCREENING_INFO + FAILED });
    return null;
  }
};

export const fetchAssignedScreenings = () => async (dispatch) => {
  dispatch({ type: FETCH_ASSIGNED_SCREENINGS + START });

  try {
    const result = await getAxiosInstance().get(
      "/patient/v1/screening/available/all_with_pupils"
    );

    dispatch({
      type: FETCH_ASSIGNED_SCREENINGS + DONE,
      payload: result.data,
    });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_ASSIGNED_SCREENINGS + FAILED });
    return null;
  }
};
export const fetchFilledFormsInfo = (payload, withReclaims = false) => async (
  dispatch
) => {
  try {
    const result = await getAxiosInstance().post(
      `/api/form_data/by_hearbox_screening_id/check_saved?withReclaims=true`,
      // `/api/form_data/by_hearbox_screening_id/check_saved${
      //   withReclaims ? `?withReclaims=true` : ``
      // }`
      payload
    );

    return result.data;
  } catch (e) {
    return null;
  }
};
export const fetchPackageInfo = (id) => async (dispatch) => {
  dispatch({ type: FETCH_PACKAGE_INFO + START });

  try {
    const result = await getAxiosInstance().get(
      `/api/examination_package/${id}`
    );

    dispatch({ type: FETCH_PACKAGE_INFO + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_PACKAGE_INFO + FAILED });
    return null;
  }
};

export const fetchPackages = (id) => async (dispatch) => {
  dispatch({ type: FETCH_PACKAGS + START });

  try {
    const result = await getAxiosInstance().get(`/api/examination_package`);

    dispatch({ type: FETCH_PACKAGS + DONE, payload: result.data });

    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_PACKAGS + FAILED });
    return null;
  }
};

//// fetch org

export const fetchOrganization = (tenantId) => async (dispatch) => {
  dispatch(fetchOrganizationStart());
  try {
    const result = await getAxiosInstance().get(
      `/api/organizations/by_tenant_id/${tenantId}`
    );
    dispatch(fetchOrganizationDone(result.data));
    return result.data;
  } catch (e) {
    dispatch(fetchOrganizationFailed(e));
  }
};

export const fetchOrganizationStart = (payload) => ({
  type: FETCH_ORGANIZATION_START,
  payload,
});

export const fetchOrganizationDone = (payload) => ({
  type: FETCH_ORGANIZATION_DONE,
  payload,
});

export const fetchOrganizationFailed = (payload) => ({
  type: FETCH_ORGANIZATION_FAILED,
  payload,
});

/////////////

export const fetchConfigGlobal = (payload, orgId) => async (dispatch) => {
  dispatch(fetchConfigGlobalStart());
  try {
    const result = await getAxiosInstance().get("/api/config_global");
    dispatch(fetchConfigGlobalDone(result.data));
    return result.data;
  } catch (e) {
    dispatch(fetchConfigGlobalFailed(e));
  }
};

export const fetchConfigGlobalStart = (payload) => ({
  type: FETCH_CONFIG_GLOBAL_START,
  payload,
});

export const fetchConfigGlobalDone = (payload) => ({
  type: FETCH_CONFIG_GLOBAL_DONE,
  payload,
});

export const fetchConfigGlobalFailed = (payload) => ({
  type: FETCH_CONFIG_GLOBAL_FAILED,
  payload,
});

export const fetchFormsStart = (payload) => ({
  type: FETCH_FORMS_START,
  payload,
});
export const fetchFormsDone = (payload) => ({
  type: FETCH_FORMS_DONE,
  payload,
});
export const fetchFormsFailed = (payload) => ({
  type: FETCH_FORMS_FAILED,
  payload,
});

export const fetchForms = ({ page, pageSize, sortBy }) => async (dispatch) => {
  dispatch(fetchFormsStart());
  try {
    //         ...(sort ? { sortBy: sort } : {}),

    const forms = (
      await getAxiosInstance().get(`/api/v2/forms`, {
        params: {
          page,
          ...(pageSize ? { pageSize } : {}),
          ...(sortBy ? { sortBy } : {}),
        },
      })
    ).data;

    dispatch(fetchFormsDone(forms));
    return true;
  } catch (e) {
    dispatch(fetchFormsFailed(e));
    return false;
  }
};

export const fetchFormsGroupsStart = (payload) => ({
  type: FETCH_FORMS_GROUPS_START,
  payload,
});
export const fetchFormsGroupsDone = (payload) => ({
  type: FETCH_FORMS_GROUPS_DONE,
  payload,
});
export const fetchFormsGroupsFailed = (payload) => ({
  type: FETCH_FORMS_GROUPS_FAILED,
  payload,
});

export const fetchAllFormsGroupsStart = (payload) => ({
  type: FETCH_ALL_FORMS_GROUPS_START,
  payload,
});
export const fetchAllFormsGroupsDone = (payload) => ({
  type: FETCH_ALL_FORMS_GROUPS_DONE,
  payload,
});
export const fetchAllFormsGroupsFailed = (payload) => ({
  type: FETCH_ALL_FORMS_GROUPS_FAILED,
  payload,
});

export const fetchAllFormsGroups = () => async (dispatch) => {
  dispatch(fetchAllFormsGroupsStart());
  try {
    const data = (await getAxiosInstance().get(`/api/form_group`)).data;

    dispatch(fetchAllFormsGroupsDone(data));
    return true;
  } catch (e) {
    dispatch(fetchAllFormsGroupsFailed(e));
    return false;
  }
};

export const fetchFormsGroups = ({ page, pageSize, sortBy }) => async (
  dispatch
) => {
  dispatch(fetchFormsGroupsStart());
  try {
    const data = (
      await getAxiosInstance().get(`/api/v2/form_group`, {
        params: {
          page,
          ...(pageSize ? { pageSize } : {}),
          ...(sortBy ? { sortBy } : {}),
        },
      })
    ).data;

    dispatch(fetchFormsGroupsDone(data));
    return true;
  } catch (e) {
    dispatch(fetchFormsGroupsFailed(e));
    return false;
  }
};

export const fetchAllowedUsersToGroupStart = (payload) => ({
  type: FETCH_ALLOWED_USERS_TO_GROUP_START,
  payload,
});
export const fetchAllowedUsersToGroupDone = (payload) => ({
  type: FETCH_ALLOWED_USERS_TO_GROUP_DONE,
  payload,
});
export const fetchAllowedUsersToGroupFailed = (payload) => ({
  type: FETCH_ALLOWED_USERS_TO_GROUP_FAILED,
  payload,
});

export const fetchAllowedUsersToGroup = (groupId) => async (dispatch) => {
  dispatch(fetchAllowedUsersToGroupStart());
  try {
    const data = (
      await getAxiosInstance().get(`/api/form_group/${groupId}/allowed_users`)
    ).data;
    dispatch(fetchAllowedUsersToGroupDone(data));
    return true;
  } catch (e) {
    dispatch(fetchAllowedUsersToGroupFailed(e));
    return false;
  }
};

export const fetchAllowedUsersToFormStart = (payload) => ({
  type: FETCH_ALLOWED_USERS_TO_FORM_START,
  payload,
});
export const fetchAllowedUsersToFormDone = (payload) => ({
  type: FETCH_ALLOWED_USERS_TO_FORM_DONE,
  payload,
});
export const fetchAllowedUsersToFormFailed = (payload) => ({
  type: FETCH_ALLOWED_USERS_TO_FORM_FAILED,
  payload,
});

export const fetchAllowedUsersToForm = (formId) => async (dispatch) => {
  dispatch(fetchAllowedUsersToFormStart());
  try {
    const data = (
      await getAxiosInstance().get(`/api/forms/${formId}/allowed_users`)
    ).data;
    dispatch(fetchAllowedUsersToFormDone(data));
    return data;
  } catch (e) {
    dispatch(fetchAllowedUsersToFormFailed(e));
    return false;
  }
};

export const copyFormToFormGroupStart = (payload) => ({
  type: COPY_FORM_TO_FORM_GROUP_START,
  payload,
});
export const copyFormToFormGroupDone = (payload) => ({
  type: COPY_FORM_TO_FORM_GROUP_DONE,
  payload,
});
export const copyFormToFormGroupFailed = (payload) => ({
  type: COPY_FORM_TO_FORM_GROUP_FAILED,
  payload,
});

export const copyFormToFormGroup = (formId, groupId) => async (dispatch) => {
  dispatch(copyFormToFormGroupStart());
  try {
    const data = (
      await getAxiosInstance().post(
        `/api/form_group/clone_form_to_group/${formId}/${groupId}`
      )
    ).data;

    dispatch(copyFormToFormGroupDone(data));
    return true;
  } catch (e) {
    dispatch(copyFormToFormGroupFailed(e));
    return false;
  }
};

export const removeFormFromFormGroupStart = (payload) => ({
  type: REMOVE_FORM_FROM_FORM_GROUP_START,
  payload,
});
export const removeFormFromFormGroupDone = (payload) => ({
  type: REMOVE_FORM_FROM_FORM_GROUP_DONE,
  payload,
});
export const removeFormFromFormGroupFailed = (payload) => ({
  type: REMOVE_FORM_FROM_FORM_GROUP_FAILED,
  payload,
});

export const removeFormFromFormGroup = (formId) => async (dispatch) => {
  dispatch(removeFormFromFormGroupStart());
  try {
    const data = (
      await getAxiosInstance().post(
        `/api/form_group/detach_form_from_group/${formId}`
      )
    ).data;

    dispatch(removeFormFromFormGroupDone(data));
    return true;
  } catch (e) {
    dispatch(removeFormFromFormGroupFailed(e));
    return false;
  }
};

export const moveFormToFormGroupStart = (payload) => ({
  type: MOVE_FORM_TO_FORM_GROUP_START,
  payload,
});
export const moveFormToFormGroupDone = (payload) => ({
  type: MOVE_FORM_TO_FORM_GROUP_DONE,
  payload,
});
export const moveFormToFormGroupFailed = (payload) => ({
  type: MOVE_FORM_TO_FORM_GROUP_FAILED,
  payload,
});

export const moveFormToFormGroup = (formId, targetGroupId) => async (
  dispatch
) => {
  dispatch(moveFormToFormGroupStart());
  try {
    const data = (
      await getAxiosInstance().post(
        `/api/form_group/move_form_to_group/${formId}/${targetGroupId}`
      )
    ).data;

    dispatch(moveFormToFormGroupDone(data));
    return true;
  } catch (e) {
    dispatch(moveFormToFormGroupFailed(e));
    return false;
  }
};

export const fetchScheduledForms = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_SCHEDULED_FORMS + START });
  try {
    const forms = (await getAxiosInstance().get("/api/forms/scheduled")).data;

    dispatch({ type: FETCH_SCHEDULED_FORMS + DONE, payload: forms });
    return true;
  } catch (e) {
    dispatch({ type: FETCH_SCHEDULED_FORMS + FAILED, payload: e });
    return false;
  }
};

export const fetchActiveForms = ({ page, pageSize, sortBy }) => async (
  dispatch
) => {
  dispatch({ type: FETCH_ACTIVE_FORMS + START });
  try {
    const forms = await getAxiosInstance().get("/api/v2/forms/active", {
      params: {
        page,
        ...(pageSize ? { pageSize } : {}),
        ...(sortBy ? { sortBy } : {}),
      },
    });

    dispatch({ type: FETCH_ACTIVE_FORMS + DONE, payload: forms.data });
    return forms;
  } catch (e) {
    dispatch({ type: FETCH_ACTIVE_FORMS + FAILED });
  }
};

export const fetchActiveFormsAll = () => async (dispatch) => {
  dispatch({ type: FETCH_ACTIVE_FORMS_ALL + START });
  try {
    const forms = await getAxiosInstance().get("/api/forms/active");

    dispatch({ type: FETCH_ACTIVE_FORMS_ALL + DONE, payload: forms.data });
    return forms;
  } catch (e) {
    dispatch({ type: FETCH_ACTIVE_FORMS_ALL + FAILED });
  }
};

export const fetchUserAllForms = (personId) => async (dispatch) => {
  dispatch({ type: FETCH_USER_ALL_FORMS + START });
  try {
    const forms = (
      await getAxiosInstance().get(`/api/forms/active-by-person/${personId}`)
    ).data;

    dispatch({ type: FETCH_USER_ALL_FORMS + DONE, payload: forms });
  } catch (e) {
    dispatch({ type: FETCH_USER_ALL_FORMS + FAILED });
  }
};

export const fetchUserAllAvailableForms = (personId, groupId) => async (
  dispatch
) => {
  dispatch({ type: FETCH_USER_ALL_AVAILABLE_FORMS + START });
  try {
    const forms = (
      await getAxiosInstance().get(
        `/api/forms/available-for-person/${personId}`,
        {
          params: {
            groupId,
          },
        }
      )
    ).data;

    dispatch({ type: FETCH_USER_ALL_AVAILABLE_FORMS + DONE, payload: forms });
  } catch (e) {
    dispatch({ type: FETCH_USER_ALL_AVAILABLE_FORMS + FAILED });
  }
};

export const fetchPlannedForms = ({ page, pageSize, sortBy }) => async (
  dispatch
) => {
  dispatch({ type: FETCH_PLANNED_FORMS + START });
  try {
    const forms = (
      await getAxiosInstance().get("/api/v2/forms/scheduled", {
        params: {
          page,
          ...(pageSize ? { pageSize } : {}),
          ...(sortBy ? { sortBy } : {}),
        },
      })
    ).data;

    dispatch({ type: FETCH_PLANNED_FORMS + DONE, payload: forms });
    return forms;
  } catch (e) {
    dispatch({ type: FETCH_PLANNED_FORMS + FAILED });
  }
};
export const fetchPlannedFormsAll = () => async (dispatch) => {
  dispatch({ type: FETCH_PLANNED_FORMS_ALL + START });
  try {
    const forms = (await getAxiosInstance().get("/api/forms/scheduled")).data;

    dispatch({ type: FETCH_PLANNED_FORMS_ALL + DONE, payload: forms });
    return forms;
  } catch (e) {
    dispatch({ type: FETCH_PLANNED_FORMS_ALL + FAILED });
  }
};

export const fetchArchivedForms = ({ page, pageSize, sortBy }) => async (
  dispatch
) => {
  dispatch({ type: FETCH_ARCHIVED_FORMS + START });
  try {
    const forms = (
      await getAxiosInstance().get("/api/v2/forms/all-my-filled-unique-bags", {
        params: {
          page,
          ...(pageSize ? { pageSize } : {}),
          ...(sortBy ? { sortBy } : {}),
        },
      })
    ).data;

    dispatch({ type: FETCH_ARCHIVED_FORMS + DONE, payload: forms });
    return forms;
  } catch (e) {
    dispatch({ type: FETCH_ARCHIVED_FORMS + FAILED });
  }
};

export const fetchArchivedFormsBag = ({ bagId }) => async (dispatch) => {
  dispatch({ type: FETCH_ARCHIVED_FORMS_BAG + START });
  try {
    const forms = (
      await getAxiosInstance().get(
        `/api/v2/forms/all-my-filled-previous/${bagId}`
      )
    ).data;

    dispatch({ type: FETCH_ARCHIVED_FORMS_BAG + DONE, payload: forms, bagId });
    return forms;
  } catch (e) {
    dispatch({ type: FETCH_ARCHIVED_FORMS_BAG + FAILED });
  }
};

export const fetchSavedFormData = ({ page, pageSize, sortBy }) => async (
  dispatch
) => {
  dispatch({ type: FETCH_SAVED_FORM_DATA + START });
  try {
    const forms = (
      await getAxiosInstance().get("/api/v2/form_data/all/my", {
        params: {
          state: "SAVED",
          page,
          ...(pageSize ? { pageSize } : {}),
          ...(sortBy ? { sortBy } : {}),
        },
      })
    ).data;

    dispatch({ type: FETCH_SAVED_FORM_DATA + DONE, payload: forms });
  } catch (e) {
    dispatch({ type: FETCH_SAVED_FORM_DATA + FAILED });
  }
};

export const fetchFilledFormData = () => async (dispatch) => {
  dispatch({ type: FETCH_FILLED_FORM_DATA + START });
  try {
    const forms = (
      await getAxiosInstance().get("/api/form_data/all/my", {
        params: {
          state: "COMPLETED",
        },
      })
    ).data;

    dispatch({ type: FETCH_FILLED_FORM_DATA + DONE, payload: forms });
  } catch (e) {
    dispatch({ type: FETCH_FILLED_FORM_DATA + FAILED });
  }
};

export const removeDraft = (id) => async (dispatch) => {
  dispatch({ type: REMOVE_FORM_DATA_DRAFT + START });
  try {
    const response = await getAxiosInstance().delete(`/api/form_data/${id}`);
    dispatch({ type: REMOVE_FORM_DATA_DRAFT + DONE, payload: { id } });
    return response;
  } catch (e) {
    dispatch({ type: REMOVE_FORM_DATA_DRAFT + FAILED });
    return e.response;
  }
};

/////////////

export const removeFormStart = (payload) => ({
  type: REMOVE_FORM_START,
  payload,
});
export const removeFormDone = (payload) => ({
  type: REMOVE_FORM_DONE,
  payload,
});
export const removeFormFailed = (payload) => ({
  type: REMOVE_FORM_FAILED,
  payload,
});

export const removeForm = (payload) => async (dispatch) => {
  dispatch(removeFormStart());
  try {
    await getAxiosInstance().delete(`/api/forms/${payload}`);

    dispatch(removeFormDone());
    dispatch(
      fetchForms({
        page: 0,
        pageSize: 100,
      })
    );
    return true;
  } catch (e) {
    dispatch(removeFormFailed(e));
    return false;
  }
};

/////////////

export const fetchFormTemplateStart = (payload) => ({
  type: FETCH_FORM_TEMPLATE_START,
  payload,
});
export const fetchFormTemplateDone = (payload) => ({
  type: FETCH_FORM_TEMPLATE_DONE,
  payload,
});
export const fetchFormTemplateFailed = (payload) => ({
  type: FETCH_FORM_TEMPLATE_FAILED,
  payload,
});

export const fetchFormTemplate = (formDataId) => async (dispatch) => {
  dispatch(fetchFormTemplateStart());
  try {
    const data = (
      await getAxiosInstance().get(`/api/form_template/${formDataId}`)
    ).data;

    dispatch(fetchFormTemplateDone(data));
    return data;
  } catch (e) {
    dispatch(fetchFormTemplateFailed(e));
    return null;
  }
};

/////////////

export const fetchFormStart = (payload) => ({
  type: FETCH_FORM_START,
  payload,
});
export const fetchFormDone = (payload) => ({ type: FETCH_FORM_DONE, payload });
export const fetchFormFailed = (payload) => ({
  type: FETCH_FORM_FAILED,
  payload,
});

export const fetchForm = (id) => async (dispatch) => {
  dispatch(fetchFormStart());
  try {
    const data = (await getAxiosInstance().get(`/api/forms/${id}`)).data;

    dispatch(fetchFormDone(data));
    return data;
  } catch (e) {
    dispatch(fetchFormFailed(e));
    return null;
  }
};

export const fetchAsDocFormByScreeningId = (
  screeningId,
  hearBoxTestId = null,
  patientId = null,
  patientScreeningId = null
) => async (dispatch) => {
  dispatch(fetchFormStart());
  try {
    const data = (
      await getAxiosInstance().get(
        `/api/form_data/medic/forms_by_patient_screening_package?screeningId=${screeningId}${
          hearBoxTestId ? `&hearBoxTestId=${hearBoxTestId}` : ``
        }${patientId ? `&patientId=${patientId}` : ``}${
          patientScreeningId ? `&patientScreeningId=${patientScreeningId}` : ``
        }`
      )
    ).data;
    dispatch(fetchFormDone(data));
    return data;
  } catch (e) {
    dispatch(fetchFormFailed(e));
    return null;
  }
};

export const fetchFormByScreeningId = (
  screeningId,
  subAccountId = null,
  hearBoxTestId = null,
  includeNonCurrentFilledForms = false,
  patientScreeningId = null
) => async (dispatch) => {
  dispatch(fetchFormStart());
  try {
    const data = (
      await getAxiosInstance().get(
        `/api/screening_form?screeningId=${screeningId}${
          subAccountId ? `&subAccountId=${subAccountId}` : ``
        }${hearBoxTestId ? `&hearBoxTestId=${hearBoxTestId}` : ``}${
          includeNonCurrentFilledForms
            ? `&includeNonCurrentFilledForms=${true}`
            : ``
        }${
          patientScreeningId ? `&patientScreeningId=${patientScreeningId}` : ``
        }`
      )
    ).data;

    dispatch(fetchFormDone(data));
    return data;
  } catch (e) {
    dispatch(fetchFormFailed(e));
    return null;
  }
};

/////////////
export const fetchFormGroupStart = (payload) => ({
  type: FETCH_FORM_GROUP_START,
  payload,
});
export const fetchFormGroupDone = (payload) => ({
  type: FETCH_FORM_GROUP_DONE,
  payload,
});
export const fetchFormGroupFailed = (payload) => ({
  type: FETCH_FORM_GROUP_FAILED,
  payload,
});

export const fetchFormGroup = (id) => async (dispatch) => {
  dispatch(fetchFormGroupStart());
  try {
    const data = (await getAxiosInstance().get(`/api/form_group/${id}`)).data;

    dispatch(fetchFormGroupDone(data));
    return true;
  } catch (e) {
    dispatch(fetchFormGroupFailed(e));
    return false;
  }
};
/////////////

/////////////

export const fetchGlobalDictionariesStart = (payload) => ({
  type: FETCH_GLOBAL_DICTIONARIES_START,
  payload,
});
export const fetchGlobalDictionariesDone = (payload) => ({
  type: FETCH_GLOBAL_DICTIONARIES_DONE,
  payload,
});
export const fetchGlobalDictionariesFailed = (payload) => ({
  type: FETCH_GLOBAL_DICTIONARIES_FAILED,
  payload,
});

export const fetchGlobalDictionaries = () => async (dispatch) => {
  dispatch(fetchGlobalDictionariesStart());
  try {
    const data = (
      await getAxiosInstance().get(`/api/form_layouts/saved_fields`)
    ).data;

    dispatch(fetchGlobalDictionariesDone(data));
    return data;
  } catch (e) {
    dispatch(fetchGlobalDictionariesFailed(e));
    return null;
  }
};

/////////////

export const createFilledFormDataStart = (payload) => ({
  type: CREATE_FILLED_FORM_DATA_START,
  payload,
});
export const createFilledFormDataDone = (payload) => ({
  type: CREATE_FILLED_FORM_DATA_DONE,
  payload,
});
export const createFilledFormDataFailed = (payload) => ({
  type: CREATE_FILLED_FORM_DATA_FAILED,
  payload,
});

export const createFilledFormData = ({
  formId,
  scheduledFormId,
  values,
  arrayValues,
  files,
  notes,
  fieldAlternativeAnswer,
  draft,
  screeningId,
  tenantId,
  filledForSubaccountId,
  mandatory,
  hearBoxTestId,
  patientScreeningId,
}) => async (dispatch) => {
  dispatch(createFilledFormDataStart());
  try {
    const payload = {
      form: {
        id: formId,
      },
    };
    const formMetadata = (
      await getAxiosInstance().post(`/api/form_metadata/`, payload)
    ).data;
    dispatch(createFilledFormDataDone(formMetadata));

    return await dispatch(
      saveFilledFormData({
        formId,
        screeningId,
        filledForSubaccountId,
        ...(!mandatory && { hearBoxTestId }),
        ...(!mandatory && { patientScreeningId }),
        tenantId,
        scheduledFormId,
        formMetadataId: formMetadata.id,
        values,
        arrayValues,
        files,
        notes,
        fieldAlternativeAnswer,
        draft,
      })
    );
  } catch (e) {
    dispatch(createFilledFormDataFailed(e));
    throw e;
  }
};

/////////////

export const saveFilledFormDataStart = (payload) => ({
  type: SAVE_FILLED_FORM_DATA_START,
  payload,
});
export const saveFilledFormDataDone = (payload) => ({
  type: SAVE_FILLED_FORM_DATA_DONE,
  payload,
});
export const saveFilledFormDataFailed = (payload) => ({
  type: SAVE_FILLED_FORM_DATA_FAILED,
  payload,
});

export const saveFilledFormData = ({
  formId,
  formMetadataId,
  scheduledFormId,
  values,
  arrayValues,
  files,
  fieldAlternativeAnswer,
  draft,
  notes,
  screeningId,
  tenantId,
  filledForSubaccountId,
  hearBoxScreeningId,
  hearBoxTestId,
  patientScreeningId,
  mandatory,
}) => async (dispatch) => {
  dispatch(saveFilledFormDataStart());
  try {
    const payload = {
      formId,
      scheduledFormId,
      data: values,
      arrayData: arrayValues,
      noteData: notes,
      filesDataUUID: files,
      formMetadataId,
      fieldAlternativeAnswer,
      screeningId,
      tenantId,
      filledForSubaccountId,
      ...(!mandatory && { hearBoxTestId }),
      ...(!mandatory && { patientScreeningId }),
    };
    const result = (
      await getAxiosInstance().post(`/api/form_data/`, payload, {
        params: { draft: false },
      })
    ).data;
    dispatch(saveFilledFormDataDone(result));

    return result;
  } catch (e) {
    dispatch(saveFilledFormDataFailed(e));
    throw e;
  }
};

export const editFilledFormDataStart = (payload) => ({
  type: EDIT_FILLED_FORM_DATA_START,
  payload,
});
export const editFilledFormDataDone = (payload) => ({
  type: EDIT_FILLED_FORM_DATA_DONE,
  payload,
});
export const editFilledFormDataFailed = (payload) => ({
  type: EDIT_FILLED_FORM_DATA_FAILED,
  payload,
});

export const editFilledFormData = (
  {
    formId,
    formMetadataId,
    scheduledFormId,
    values,
    arrayValues,
    fieldAlternativeAnswer,
    files,
    draft,
    notes,
  },
  formDataId
) => async (dispatch) => {
  dispatch(editFilledFormDataStart());
  try {
    const payload = {
      formId,
      scheduledFormId,
      data: values,
      arrayData: arrayValues,
      formMetadataId,
      fieldAlternativeAnswer,
      filesDataUUID: files,
      noteData: notes,
    };
    const result = (
      await getAxiosInstance().put(`/api/form_data/${formDataId}`, payload, {
        params: {
          draft,
        },
      })
    ).data;
    dispatch(editFilledFormDataDone(result));

    return result;
  } catch (e) {
    dispatch(editFilledFormDataFailed(e));
    if (
      e.response.data.code === "500" &&
      e.response.data.message === "HTTP 404 Not Found"
    ) {
      return false;
    }
    throw e;
  }
};

/////////////

export const fetchFilledFormsStart = (payload) => ({
  type: FETCH_FILLED_FORMS_START,
  payload,
});
export const fetchFilledFormsDone = (payload) => ({
  type: FETCH_FILLED_FORMS_DONE,
  payload,
});
export const fetchFilledFormsFailed = (payload) => ({
  type: FETCH_FILLED_FORMS_FAILED,
  payload,
});

export const fetchFilledForms = (formId) => async (dispatch) => {
  dispatch(fetchFilledFormsStart());
  try {
    const result = (
      await getAxiosInstance().get(`/api/form_data/by_form_id/${formId}`)
    ).data;
    dispatch(
      fetchFilledFormsDone({
        formId,
        data: result,
      })
    );

    return result;
  } catch (e) {
    dispatch(fetchFilledFormsFailed(e));
    return false;
  }
};

export const fetchAsDocFilledFormsExtended = (
  formId,
  screeningId,
  hearBoxTestId,
  hearBoxScreeningId,
  patientId,
  patientScreeningId,
  screeningType
  // { showMissedForms, ...body }
) => async (dispatch) => {
  dispatch({ type: FETCH_FILLED_FORMS_EXTENDED + START });
  try {
    let result = (
      await getAxiosInstance().post(
        `/api/form_data/medic/by_form_id_extended/${formId}`,
        {
          q: JSON.stringify({
            screeningId: { is: screeningId },
            ...(hearBoxTestId && {
              hearBoxTestId: { is: hearBoxTestId },
            }),
            // ...(patientId && {
            //   patientId: { is: patientId },
            // }),
            // ...(hearBoxScreeningId && {
            //   hearBoxScreeningId: { is: hearBoxScreeningId },
            // }),
          }),
        }
      )
    ).data;

    result = {
      ...result,
      data: result.data.filter(
        ({
          filledBy: { id },
          filledForSubaccountId,
          patientScreeningId: pScreeningId,
          reclaimedAt,
        }) =>
          !reclaimedAt &&
          (screeningType === "Commercial"
            ? (!filledForSubaccountId
                ? id === patientId
                : filledForSubaccountId === patientId) &&
              patientScreeningId === pScreeningId
            : !filledForSubaccountId
            ? id === patientId
            : filledForSubaccountId === patientId)
      ),
    };

    console.log("result", result);

    dispatch({
      type: FETCH_FILLED_FORMS_EXTENDED + DONE,
      payload: {
        formId,
        result: {
          ...result,
          data: result.data.filter(
            ({ filledBy: { id }, filledForSubaccountId }) =>
              id === patientId || filledForSubaccountId === patientId
          ),
        },
      },
    });

    return result;
  } catch (e) {
    dispatch({ type: FETCH_FILLED_FORMS_EXTENDED + FAILED, payload: e });
    return false;
  }
};

export const fetchFilledFormsExtended = (
  formId,
  screeningId,
  hearBoxTestId,
  hearBoxScreeningId,
  patientScreeningId = "",
  filledForSubaccountId = ""
  // { showMissedForms, ...body }
) => async (dispatch) => {
  dispatch({ type: FETCH_FILLED_FORMS_EXTENDED + START });
  try {
    const result = (
      await getAxiosInstance().post(
        `/api/form_data/by_form_id_extended/${formId}?hearBoxScreeningId=${hearBoxScreeningId}${
          filledForSubaccountId
            ? `&subaccountId=${filledForSubaccountId}`
            : `&onlyMainAccount=${true}`
        }
        `,
        {
          q: JSON.stringify({
            screeningId: { is: screeningId },
            ...(hearBoxTestId && {
              hearBoxTestId: { is: hearBoxTestId },
            }),
            ...(patientScreeningId && {
              patientScreeningId: { is: patientScreeningId },
            }),
          }),
        }
      )
    ).data;
    dispatch({
      type: FETCH_FILLED_FORMS_EXTENDED + DONE,
      payload: {
        formId,
        result,
      },
    });

    return result;
  } catch (e) {
    dispatch({ type: FETCH_FILLED_FORMS_EXTENDED + FAILED, payload: e });
    return false;
  }
};

const recoverPasswordStart = (payload) => ({
  type: RECOVER_PASSWORD_START,
  payload,
});
const recoverPasswordDone = (payload) => ({
  type: RECOVER_PASSWORD_DONE,
  payload,
});
const recoverPasswordFailed = (payload) => ({
  type: RECOVER_PASSWORD_FAILED,
  payload,
});
export const recoverPassword = ({ email, phone, role }) => async (dispatch) => {
  dispatch(recoverPasswordStart());
  try {
    const result =
      role !== "patient"
        ? await getAxiosInstance().post(`/employees/v1/password/reset/ask`, {
            email,
            lang: "pl",
          })
        : await getAxiosInstance().post(`/api/auth/recover_password`, {
            email,
            phone,
            lang: "pl",
          });
    const data = result.data;
    dispatch(recoverPasswordDone(data));

    return result;
  } catch (e) {
    dispatch(recoverPasswordFailed(e));
    return false;
  }
};

const resetByMailPasswordStart = (payload) => ({
  type: RESET_BY_MAIL_PASSWORD_START,
  payload,
});
const resetByMailPasswordDone = (payload) => ({
  type: RESET_BY_MAIL_PASSWORD_DONE,
  payload,
});
const resetByMailPasswordFailed = (payload) => ({
  type: RESET_BY_MAIL_PASSWORD_FAILED,
  payload,
});

export const resetByMailPassword = ({
  email,
  resetId,
  role,
  newPassword,
}) => async (dispatch) => {
  dispatch(resetByMailPasswordStart());
  try {
    role !== "user"
      ? await getAxiosInstance().post(`/employees/v1/password/reset`, {
          email,
          resetId,
          newPassword,
        })
      : await getAxiosInstance().post(`/api/auth/change_password`, {
          email,
          resetId,
          newPassword,
        });
    dispatch(resetByMailPasswordDone());
    return true;
  } catch (e) {
    dispatch(resetByMailPasswordFailed(e));
    return false;
  }
};

export const alertAdd = (payload) => ({ type: ALERT_SHOW, payload });
export const alertHide = (payload) => ({ type: ALERT_HIDE, payload });
export const alertHideCustomId = (payload) => ({
  type: ALERT_HIDE_CUSTOM_ID,
  payload,
});
export const alertTimeout = (payload) => ({ type: ALERT_TIMEOUT, payload });

const sendCommentStart = () => ({ type: SEND_COMMENT_START });
const sendCommentDone = () => ({ type: SEND_COMMENT_DONE });
const sendCommentFailed = () => ({ type: SEND_COMMENT_FAILED });
export const sendComment = ({ url, text }) => async (dispatch) => {
  dispatch(sendCommentStart());
  try {
    const result = await getAxiosInstance().post(`/api/site-comment`, {
      url,
      text,
    });
    dispatch(sendCommentDone());

    return result;
  } catch (e) {
    dispatch(sendCommentFailed(e));
    return false;
  }
};

export const activateForm = ({ id }) => async (dispatch) => {
  dispatch({ type: ACTIVATE_FORM + START });
  try {
    const result = await getAxiosInstance().put(`/api/forms/${id}/activate`);
    dispatch({ type: ACTIVATE_FORM + DONE, payload: result.data });

    return result.data;
  } catch (e) {
    dispatch({ type: ACTIVATE_FORM + FAILED, payload: e });
    throw e;
  }
};

export const removeUserStart = (payload) => ({
  type: REMOVE_USER + START,
  payload,
});
export const removeUserDone = (payload) => ({
  type: REMOVE_USER + DONE,
  payload,
});
export const removeUserFailed = (payload) => ({
  type: REMOVE_USER + FAILED,
  payload,
});

export const removeUser = (userId, canSeeTerms) => async (dispatch) => {
  dispatch(removeUserStart());
  try {
    const result = await getAxiosInstance().delete(`/api/v1/users/${userId}`);
    dispatch(removeUserDone(result));
    canSeeTerms
      ? dispatch(fetchOrgUsersWithTerms())
      : dispatch(fetchOrgUsers());

    return result;
  } catch (e) {
    dispatch(removeUserFailed(e));
    return false;
  }
};

export const editUserStart = (payload) => ({ type: EDIT_USER, payload });
export const editUserDone = (payload) => ({
  type: EDIT_USER + DONE,
  payload,
});
export const editUserFailed = (payload) => ({
  type: EDIT_USER + FAILED,
  payload,
});

export const editUser = (user) => async (dispatch) => {
  dispatch(editUserStart());
  try {
    const result = await getAxiosInstance().put(
      `/api/persons/${user.id}/update`,
      {
        hospitalIdentifier: user.hospitalIdentifier,
        firstName: user.firstName,
        surname: user.surname,
        ...(user.phone && user.phone !== "+48"
          ? { phone: user.phone }
          : { phone: null }),
        mail: user.mail,
        title: user.title,
        description: user.description,
        gender: user.gender,
        address: user.address,
        // enableAllForms: user.enableAllForms,
        enableProfileDataEdition: user.enableProfileDataEdition,
      }
    );
    const my = await getAxiosInstance().get("/api/persons/my");

    dispatch(editUserDone({ result: result, my: my.data }));
    // dispatch(fetchOrgUsers());

    return result;
  } catch (e) {
    dispatch(editUserFailed(e));
    return e.response;
  }
};

export const fetchMatchingUsersStart = (payload) => ({
  type: FETCH_MATCHING_USERS + START,
  payload,
});
export const fetchMatchingUsersDone = (payload) => ({
  type: FETCH_MATCHING_USERS + DONE,
  payload,
});
export const fetchMatchingUsersFailed = (payload) => ({
  type: FETCH_MATCHING_USERS + FAILED,
  payload,
});

export const fetchMatchingUsers = (data) => async (dispatch) => {
  dispatch(fetchMatchingUsersStart());
  try {
    const result = await getAxiosInstance().post(
      `/api/organizations/fetch_matching_users`,
      data
    );
    dispatch(fetchMatchingUsersDone({ result: result }));
    return result;
  } catch (e) {
    dispatch(fetchMatchingUsersFailed(e));
    return e.response;
  }
};

export const activateUserStart = (payload) => ({
  type: ACTIVATE_USER,
  payload,
});
export const activateUserDone = (payload) => ({
  type: ACTIVATE_USER + DONE,
  payload,
});
export const activateUserFailed = (payload) => ({
  type: ACTIVATE_USER + FAILED,
  payload,
});

export const activateUser = (userId) => async (dispatch) => {
  dispatch(activateUserStart());
  try {
    const result = await getAxiosInstance().put(
      `/api/v1/users/${userId}/activate`
    );
    dispatch(activateUserDone(result));
    dispatch(fetchOrgUsers());

    return result;
  } catch (e) {
    dispatch(activateUserFailed(e));
    return false;
  }
};

export const updateEntitledUsersStart = (payload) => ({
  type: UPDATE_ENTITLED_USERS + START,
  payload,
});
export const updateEntitledUsersDone = (payload) => ({
  type: UPDATE_ENTITLED_USERS + DONE,
  payload,
});
export const updateEntitledUsersFailed = (payload) => ({
  type: UPDATE_ENTITLED_USERS + FAILED,
  payload,
});

export const updateEntitledUsers = (formId, emails) => async (dispatch) => {
  dispatch(updateEntitledUsersStart());
  try {
    const result = await getAxiosInstance().put(
      `/api/forms/${formId}/entitled_users`,
      {
        users: emails.map((email) => ({
          username: email,
        })),
      }
    );
    dispatch(updateEntitledUsersDone(result.data));

    return result.data;
  } catch (e) {
    dispatch(updateEntitledUsersFailed(e));
    return false;
  }
};

export const updateUsersAccessToGroupStart = (payload) => ({
  type: UPDATE_USERS_ACCESS_TO_GROUP + START,
  payload,
});
export const updateUsersAccessToGroupDone = (payload) => ({
  type: UPDATE_USERS_ACCESS_TO_GROUP + DONE,
  payload,
});
export const updateUsersAccessToGroupFailed = (payload) => ({
  type: UPDATE_USERS_ACCESS_TO_GROUP + FAILED,
  payload,
});

export const updateUsersAccessToGroup = (groupId, usersIDs) => async (
  dispatch
) => {
  dispatch(updateUsersAccessToGroupStart());
  try {
    const result = await getAxiosInstance().put(
      `/api/form_group/${groupId}/allowed_users`,
      usersIDs
    );
    dispatch(updateUsersAccessToGroupDone(result.data));

    return result.data;
  } catch (e) {
    dispatch(updateUsersAccessToGroupFailed(e));
    return false;
  }
};

export const updateUsersAccessToFormStart = (payload) => ({
  type: UPDATE_USERS_ACCESS_TO_FORM + START,
  payload,
});
export const updateUsersAccessToFormDone = (payload) => ({
  type: UPDATE_USERS_ACCESS_TO_FORM + DONE,
  payload,
});
export const updateUsersAccessToFormFailed = (payload) => ({
  type: UPDATE_USERS_ACCESS_TO_FORM + FAILED,
  payload,
});

export const updateUsersAccessToForm = (formId, selectedUsers) => async (
  dispatch
) => {
  dispatch(updateUsersAccessToFormStart());
  try {
    const result = await getAxiosInstance().put(
      `/api/forms/${formId}/allowed_users`,
      selectedUsers
    );
    dispatch(updateUsersAccessToFormDone(result.data));

    return result.data;
  } catch (e) {
    dispatch(updateUsersAccessToFormFailed(e));
    return false;
  }
};

export const fetchFormEditions = (formId) => async (dispatch) => {
  dispatch({ type: FETCH_FORM_EDITIONS + START });
  try {
    const result = await getAxiosInstance().get(
      `/api/form_data/editions_by_form_id/${formId}`
    );
    dispatch({ type: FETCH_FORM_EDITIONS + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_FORM_EDITIONS + FAILED, payload: e });
  }
};

export const fetchOldFormEditions = (formId) => async (dispatch) => {
  dispatch({ type: FETCH_OLD_FORM_EDITIONS + START });
  try {
    const result = await getAxiosInstance().get(
      `/api/forms/${formId}/old_versions`
    );
    dispatch({ type: FETCH_OLD_FORM_EDITIONS + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_OLD_FORM_EDITIONS + FAILED, payload: e });
  }
};

export const fetchDataAsCSV = ({
  formId,
  includePersonalData,
  personId,
  showMissedForms,
}) => async (dispatch) => {
  dispatch({ type: FETCH_DATA_AS_CSV + START });
  try {
    const result = await getAxiosInstance().get(
      `/api/form_data/csv/${formId}`,
      {
        params: {
          includePersonalData,
          includeMissingData: showMissedForms,
          personId,
        },
      }
    );
    dispatch({ type: FETCH_DATA_AS_CSV + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_DATA_AS_CSV + FAILED, payload: e });
  }
};

export const addItemToCart = (payload) => async (dispatch) => {
  dispatch({ type: ADD_ITEM_TO_CART + START });
  try {
    const result = await getAxiosInstance().post(`/api/cart`, payload);
    dispatch({ type: ADD_ITEM_TO_CART + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: ADD_ITEM_TO_CART + FAILED, payload: e });
  }
};

export const editItemCart = (id, payload) => async (dispatch) => {
  dispatch({ type: EDIT_ITEM_CART + START });
  try {
    const result = await getAxiosInstance().put(`/api/cart/${id}`, payload);
    dispatch({ type: EDIT_ITEM_CART + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: EDIT_ITEM_CART + FAILED, payload: e });
  }
};

export const removeFromCart = (id) => async (dispatch) => {
  dispatch({ type: REMOVE_ITEM_FROM_CART + START });
  try {
    const result = await getAxiosInstance().delete(`/api/cart/${id}`);
    dispatch({ type: REMOVE_ITEM_FROM_CART + DONE, payload: id });
    return result.data;
  } catch (e) {
    dispatch({ type: REMOVE_ITEM_FROM_CART + FAILED, payload: e });
  }
};

export const fetchAllMyTests = () => async (dispatch) => {
  dispatch({ type: FETCH_ALL_MY_TESTS + START });
  try {
    const result = await getAxiosInstance().get(`/api/form_data/all/my`, {
      params: {
        sortBy: "createdBy",
        sortOrder: "asc",
      },
    });
    dispatch({ type: FETCH_ALL_MY_TESTS + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_ALL_MY_TESTS + FAILED, payload: e });
  }
};

export const fetchFilledTests = (params) => async (dispatch) => {
  dispatch({ type: FETCH_FILLED_TESTS + START });
  try {
    const result = await getAxiosInstance().get("/api/form_data/all/my", {
      params,
    });
    dispatch({ type: FETCH_FILLED_TESTS + DONE, payload: result.data });

    return result.data;
  } catch (payload) {
    dispatch({ type: FETCH_FILLED_TESTS + FAILED, payload });
    return false;
  }
};

export const fetchActivatedKits = () => async (dispatch) => {
  dispatch({ type: FETCH_ACTIVATED_KITS + START });
  try {
    const result = await getAxiosInstance().get(
      `/api/forms/scheduled/activated`
    );
    dispatch({ type: FETCH_ACTIVATED_KITS + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_ACTIVATED_KITS + FAILED, payload: e });
  }
};

export const toggleRequestedSharingByOwner = (scheduledFormId) => async (
  dispatch
) => {
  dispatch({ type: TOGGLE_REQUESTED_SHARING_BY_OWNER + START });
  try {
    const result = await getAxiosInstance().patch(
      `/api/forms/scheduled/${scheduledFormId}/toggle-requested-sharing-by-owner`
    );
    dispatch({
      type: TOGGLE_REQUESTED_SHARING_BY_OWNER + DONE,
      payload: result.data,
    });
    return result.data;
  } catch (e) {
    dispatch({ type: TOGGLE_REQUESTED_SHARING_BY_OWNER + FAILED, payload: e });
  }
};

export const updateRequestedSharingByOwner = (
  scheduledFormId,
  enable
) => async (dispatch) => {
  dispatch({ type: UPDATE_REQUESTED_SHARING_BY_OWNER + START });
  try {
    const result = await getAxiosInstance().patch(
      `/api/forms/scheduled/${scheduledFormId}/${
        enable ? "enable" : "disable"
      }-requested-sharing-by-owner`
    );
    dispatch({
      type: UPDATE_REQUESTED_SHARING_BY_OWNER + DONE,
      payload: result.data,
    });
    return result.data;
  } catch (e) {
    dispatch({ type: UPDATE_REQUESTED_SHARING_BY_OWNER + FAILED, payload: e });
  }
};

export const updateSharingFormData = (formDataId, enable) => async (
  dispatch
) => {
  dispatch({ type: UPDATE_FORM_DATA_IS_SHARED + START });
  try {
    const result = await getAxiosInstance().patch(
      `/api/form_data/${formDataId}/${enable ? "enable" : "disable"}-sharing`
    );
    dispatch({
      type: UPDATE_FORM_DATA_IS_SHARED + DONE,
      payload: result.data,
    });
    return result.data;
  } catch (e) {
    dispatch({ type: UPDATE_FORM_DATA_IS_SHARED + FAILED, payload: e });
  }
};

export const setAppBarTitle = (title) => async (dispatch) => {
  dispatch({
    type: SET_APP_BAR_TITLE,
    payload: { title },
  });
};

/**
 * This will fetch the following order details:
 * - all kits that were part of this order
 * - all tests that were in the kit
 * - all results of the tests that were already conducted
 * @param data
 * @returns {function(*): Promise<*|undefined>}
 */
export const fetchOrderDetailsByOrderId = (orderId) => async (dispatch) => {
  dispatch({ type: FETCH_ORDER_DETAILS_BY_ORDER_ID + START });
  try {
    const result = await getAxiosInstance().get(`/api/orders/${orderId}`);
    dispatch({
      type: FETCH_ORDER_DETAILS_BY_ORDER_ID + DONE,
      payload: result.data,
    });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_ORDER_DETAILS_BY_ORDER_ID + FAILED, payload: e });
  }
};

export const fetchFormData = (formDataId) => async (dispatch) => {
  dispatch({ type: FETCH_FORM_DATA + START });
  try {
    const result = await getAxiosInstance().get(`/api/form_data/${formDataId}`);
    dispatch({
      type: FETCH_FORM_DATA + DONE,
      payload: result.data,
    });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_FORM_DATA + FAILED, payload: e });
    return e.response;
  }
};

export const fetchUploadableFileTypes = (formDataId) => async (dispatch) => {
  dispatch({ type: FETCH_UPLOADABLE_FILE_TYPES + START });
  try {
    const result = await getAxiosInstance().get(
      `/api/form_data/upload/file_types`
    );
    dispatch({
      type: FETCH_UPLOADABLE_FILE_TYPES + DONE,
      payload: result.data,
    });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_UPLOADABLE_FILE_TYPES + FAILED, payload: e });
  }
};

export const fetchFormsScheduledForFuture = ({
  page,
  pageSize,
  sortBy,
}) => async (dispatch) => {
  dispatch({ type: FETCH_FORMS_SCHEDULED_FOR_FUTURE + START });
  try {
    const result = await getAxiosInstance().get(
      `/api/v2/forms/scheduled-for-future`,
      {
        params: {
          page,
          ...(pageSize ? { pageSize } : {}),
          ...(sortBy ? { sortBy } : {}),
        },
      }
    );
    dispatch({
      type: FETCH_FORMS_SCHEDULED_FOR_FUTURE + DONE,
      payload: result.data,
    });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_FORMS_SCHEDULED_FOR_FUTURE + FAILED, payload: e });
  }
};

export const resetGivenUserPassword = (id) => async (dispatch) => {
  dispatch({ type: RESET_GIVEN_USER_PASSWORD + START });
  try {
    const result = await getAxiosInstance().put(
      `/api/persons/${id}/reset_password`
    );
    dispatch({
      type: RESET_GIVEN_USER_PASSWORD + DONE,
      payload: result.data,
    });
    return result;
  } catch (e) {
    dispatch({ type: RESET_GIVEN_USER_PASSWORD + FAILED, payload: e });
    return e.response;
  }
};

export const fetchApiKeys = () => async (dispatch) => {
  dispatch({ type: FETCH_API_KEYS + START });
  try {
    const result = await getAxiosInstance().get(`/employees/v1/tokens`);
    dispatch({
      type: FETCH_API_KEYS + DONE,
    });
    return result;
  } catch (e) {
    dispatch({ type: FETCH_API_KEYS + FAILED, payload: e });
    return e.response;
  }
};

export const addApiKey = (payload) => async (dispatch) => {
  dispatch({ type: ADD_API_KEY + START });
  try {
    const result = await getAxiosInstance().post(`/employees/v1/tokens`, {
      ...payload,
    });
    dispatch({
      type: ADD_API_KEY + DONE,
      payload: result.data,
    });
    return result;
  } catch (e) {
    dispatch({ type: ADD_API_KEY + FAILED, payload: e });
    return e.response;
  }
};

export const deleteApiKey = (tokenId) => async (dispatch) => {
  dispatch({ type: DELEETE_API_KEY + START });
  try {
    const result = await getAxiosInstance().delete(`/employees/v1/tokens`, {
      params: {
        tokenId,
      },
    });
    dispatch({
      type: DELEETE_API_KEY + DONE,
    });
    return result;
  } catch (e) {
    dispatch({ type: DELEETE_API_KEY + FAILED, payload: e });
    return e.response;
  }
};

export const fetchScheduledForm = (id) => async (dispatch) => {
  dispatch({ type: FETCH_SCHEDULED_FORM + START });
  try {
    const form = (await getAxiosInstance().get(`/api/forms/scheduled/${id}`))
      .data;

    dispatch({ type: FETCH_SCHEDULED_FORM + DONE, payload: form });
    return form;
  } catch (e) {
    dispatch({ type: FETCH_SCHEDULED_FORM + FAILED, payload: e });
    throw e.response;
  }
};

export const fetchHasSingleScheduledForm = () => async (dispatch) => {
  dispatch({ type: FETCH_HAS_SINGLE_SCHEDULED_FORM + START });
  try {
    const data = (
      await getAxiosInstance().get(`/api/forms/has-only-one-scheduled-form`)
    ).data;

    dispatch({ type: FETCH_HAS_SINGLE_SCHEDULED_FORM + DONE, payload: data });
    return data;
  } catch (e) {
    dispatch({ type: FETCH_HAS_SINGLE_SCHEDULED_FORM + FAILED, payload: e });
    throw e.response;
  }
};

export const checkMyIdentity = () => async (dispatch) => {
  try {
    const result = await getAxiosInstance().get(`/api/persons/my`);
    return result;
  } catch (e) {
    return e.response;
  }
};

export const toggleGlobalTheme = () => async (dispatch) => {
  dispatch({ type: TOGGLE_GLOBAL_THEME + DONE });
  return {
    type: TOGGLE_GLOBAL_THEME,
  };
};

export const setCookiesAccepted = () => async (dispatch) => {
  dispatch({ type: COOKIES_ACCEPTED + DONE });
  return {
    type: COOKIES_ACCEPTED,
  };
};
export const readGlobalTheme = () => {
  return {
    type: READ_GLOBAL_THEME,
  };
};

export const fetchCookiesAccepted = () => {
  return {
    type: FETCH_COOKIES_ACCEPTED,
  };
};
export const readFontSize = () => {
  return {
    type: READ_FONT_SIZE,
  };
};

export const setFontSize = (fontSize) => async (dispatch) => {
  dispatch({ type: SET_FONT_SIZE + DONE, payload: fontSize });
  return {
    fontSize: SET_FONT_SIZE,
  };
};

export const fetchConfig = () => async (dispatch) => {
  dispatch({ type: FETCH_CONFIG + START });
  try {
    const result = await getAxiosInstance().get(`/api/config`);
    dispatch({ type: FETCH_CONFIG + DONE, payload: result.data });
    return result.response;
  } catch (e) {
    dispatch({ type: FETCH_CONFIG + FAILED });
    return e.response;
  }
};

export const clearAllFormData = () => {
  return {
    type: CLEAR_ALL_FORM,
  };
};

export const fetchTermsAcceptedByUserWithId = (userId) => async (dispatch) => {
  dispatch({ type: FETCH_TERMS_ACCEPTED_BY_USER_WITH_ID + START });
  try {
    const result = await getAxiosInstance().get(
      `/api/organizations/terms/accepted/${userId}`
    );
    dispatch({
      type: FETCH_TERMS_ACCEPTED_BY_USER_WITH_ID + DONE,
      payload: result.data,
    });

    return result.data;
  } catch (payload) {
    dispatch({ type: FETCH_TERMS_ACCEPTED_BY_USER_WITH_ID + FAILED, payload });
    return false;
  }
};

export const checkApiVersion = () => async (dispatch) => {
  dispatch({ type: FETCH_API_VERSION + START });
  try {
    const result = await getAxiosInstance().get(`/api/version`);
    dispatch({ type: FETCH_API_VERSION + DONE, payload: result.data.version });
  } catch (error) {
    dispatch({ type: FETCH_API_VERSION + FAILED });
  }
};

export const setUnsupportedBrowser = (value) => {
  return {
    type: UNSUPPORTED_BROWSER,
    payload: value,
  };
};

export const sendContact = ({ name, mail, messageText }) => async (
  dispatch
) => {
  dispatch({ type: SEND_CONTACT + START });
  try {
    const result = await getAxiosInstance().post("/api/contact", {
      name: name,
      mail: mail,
      messageText: messageText,
    });

    dispatch({ type: SEND_CONTACT + DONE, payload: result.data });
    return true;
  } catch (e) {
    dispatch({ type: SEND_CONTACT + FAILED });
  }
};

export const saveQRCode = (payload) => async (dispatch) => {
  dispatch({ type: SAVE_QR_CODE + START });
  try {
    const result = await getAxiosInstance().post(`/api/qr/save_my_qr`, payload);
    dispatch({ type: SAVE_QR_CODE + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: SAVE_QR_CODE + FAILED });
    return null;
  }
};

export const addProductToCart = (payload) => async (dispatch) => {
  dispatch({ type: ADD_PRODUCT + START });
  try {
    const result = await getAxiosInstance().post(`/api/cart`, payload);
    dispatch({ type: ADD_PRODUCT + DONE, payload: result.data });

    return result.data;
  } catch (e) {
    dispatch({ type: ADD_PRODUCT + FAILED, e });
    throw e;
  }
};
export const editProductInCart = ({ id, amount }) => async (dispatch) => {
  dispatch({ type: EDIT_PRODUCT + START });
  try {
    const result = await getAxiosInstance().put(`/api/cart/${id}`, { amount });
    dispatch({ type: EDIT_PRODUCT + DONE, payload: result.data });

    return result.data;
  } catch (e) {
    dispatch({ type: EDIT_PRODUCT + FAILED, e });
    throw e;
  }
};
export const removeProductInCart = ({ id }) => async (dispatch) => {
  dispatch({ type: REMOVE_PRODUCT + START });
  try {
    const result = await getAxiosInstance().delete(`/api/cart/${id}`);
    dispatch({ type: REMOVE_PRODUCT + DONE, payload: result.data });

    return true;
  } catch (e) {
    dispatch({ type: REMOVE_PRODUCT + FAILED, e });
    throw e;
  }
};

export const fetchShoppingCartProducts = (payload) => async (dispatch) => {
  dispatch({ type: GET_PRODUCTS + START });
  try {
    const result = await getAxiosInstance().get(`/api/cart`);
    dispatch({ type: GET_PRODUCTS + DONE, payload: result.data });

    return result.data;
  } catch (e) {
    dispatch({ type: GET_PRODUCTS + FAILED, e });
    throw e;
  }
};

export const fetchPurchasedProducts = (payload) => async (dispatch) => {
  dispatch({ type: GET_PURCHASED_PRODUCTS + START });
  try {
    const result = await getAxiosInstance().get(`/api/order`, {
      params: payload,
    });
    dispatch({ type: GET_PURCHASED_PRODUCTS + DONE, payload: result.data });

    return result.data;
  } catch (e) {
    dispatch({ type: GET_PURCHASED_PRODUCTS + FAILED, e });
    throw e;
  }
};

export const fetchOrderDetails = (id) => async (dispatch) => {
  dispatch({ type: GET_ORDER_DETAILS + START });
  try {
    const result = await getAxiosInstance().get(`/api/order/${id}`);
    dispatch({ type: GET_ORDER_DETAILS + DONE, payload: result.data });

    return result.data;
  } catch (e) {
    dispatch({ type: GET_ORDER_DETAILS + FAILED, e });
    throw e;
  }
};

export const fetchStands = () => async (dispatch) => {
  dispatch({ type: FETCH_STANDS + START });
  try {
    const result = await getAxiosInstance().get(
      "/screening/v1/patient/station/open/all"
    );
    dispatch({ type: FETCH_STANDS + DONE, payload: result.data });

    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_STANDS + FAILED, e });
    throw e;
  }
};

export const fetchStandsWithPupils = () => async (dispatch) => {
  dispatch({ type: FETCH_STANDS_WITH_PUPILS + START });
  try {
    const result = await getAxiosInstance().get(
      "/screening/v1/patient/station/available_with_pupils"
    );
    dispatch({ type: FETCH_STANDS_WITH_PUPILS + DONE, payload: result.data });

    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_STANDS_WITH_PUPILS + FAILED, e });
    throw e;
  }
};
